<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>预约服务</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="padding-bottom: 10px;text-align: right;border-bottom: 1px solid #EDEDED;">
          <el-button type="primary" @click="addddd()">新增</el-button>
        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%">
          <el-table-column
            label="头像"
            width="120">
            <template slot-scope="scope">
              <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.cover_url"
                   alt="" width="80"  height="80">
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="name">
          </el-table-column>
          <el-table-column
            label="职称"
            prop="tags">
          </el-table-column>
          <el-table-column
            label="分类"
            prop="service_content">
          </el-table-column>


          <el-table-column
            label="价格"
            prop="price"
            width="100">
          </el-table-column>

          <el-table-column
            label="详情页">
            <template slot-scope="scope">
              <el-button  @click="showOrderDetails(scope.row)">查看</el-button>
            </template>
          </el-table-column>

          <el-table-column
            label="接单状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.jdstate"
                @change="changeStateJd(scope.row.master_id,scope.row.jdstate)"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button  @click="editvalue(scope.row)" size="small" type="text">修改</el-button>
              <el-button @click="changevaluestate(scope.row.master_id,0)" size="small" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>

    </el-row>
    <el-dialog title="详情" :visible.sync="DetailsVisible" :modal-append-to-body="false">
      <el-table :data="detailsOrderData"
                style="text-align: left">
        <el-table-column  property="name" label="用户名"></el-table-column>
        <el-table-column  property="mastername" label="大师名"></el-table-column>
        <el-table-column  property="time" label="时间点"></el-table-column>
        <el-table-column  property="gender" label="性别"></el-table-column>
        <el-table-column  property="birthday" label="生日"></el-table-column>
        <el-table-column  property="user_wx" label="微信"></el-table-column>
        <el-table-column  property="user_qq" label="QQ"></el-table-column>
        <el-table-column  property="user_phone" label="电话"></el-table-column>
        <el-table-column  property="day" label="日期"></el-table-column>
        <el-table-column width="200" label="下单日期">
          <template slot-scope="scope">
            {{ formatDate(scope.row.addtime) }}
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 20px">
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <el-pagination
            style="text-align: right"
            background
            @size-change="ODhandleSizeChange"
            @current-change="ODhandleCurrentChange"
            :current-page="ODcurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="ODpagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ODdatatotal">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="新增" :visible.sync="addVisible" width="360px" :modal-append-to-body="false">
      <el-form :model="adddata" :rules="addrules" ref="adddata" style="text-align: left">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input clearable v-model="adddata.name" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="价格" :label-width="formLabelWidth" prop="price">
          <el-input clearable v-model="adddata.price" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="评分" :label-width="formLabelWidth" prop="score">
          <el-input clearable v-model="adddata.score" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="服务内容" :label-width="formLabelWidth" prop="service_content">
          <el-input clearable v-model="adddata.service_content" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="封面地址" :label-width="formLabelWidth" prop="title">
          <div class="oss_file">
            <input type="file" id="addupload1" @change="adddoUpload(1)" value="" accept="image/*"/>
            <div style="text-align: left">
              <img v-if="adddata.cover_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+adddata.cover_url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
        <el-form-item label="头像地址" :label-width="formLabelWidth" prop="title">
          <div class="oss_file">
            <input type="file" id="addupload2" @change="adddoUpload(2)" value="" accept="image/*"/>
            <div style="text-align: left">
              <img v-if="adddata.headimg_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+adddata.headimg_url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-tag
            :key="index"
            v-for="(tag,index) in tags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitadd('adddata')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="editVisible" width="360px" :modal-append-to-body="false">
      <el-form :model="editdata" :rules="editrules" ref="editdata" style="text-align: left">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input clearable v-model="editdata.name" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="价格" :label-width="formLabelWidth" prop="price">
          <el-input clearable v-model="editdata.price" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="评分" :label-width="formLabelWidth" prop="score">
          <el-input clearable v-model="editdata.score" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="服务内容" :label-width="formLabelWidth" prop="service_content">
          <el-input clearable v-model="editdata.service_content" auto-complete="off" placeholder="请输入"
                    required></el-input>
        </el-form-item>
        <el-form-item label="封面地址" :label-width="formLabelWidth" prop="title">
          <div class="oss_file">
            <input type="file" id="editupload1" @change="editdoUpload(1)" value="" accept="image/*"/>
            <div style="text-align: left">
              <img v-if="editdata.cover_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+editdata.cover_url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
        <el-form-item label="头像地址" :label-width="formLabelWidth" prop="title">
          <div class="oss_file">
            <input type="file" id="editupload2" @change="editdoUpload(2)" value="" accept="image/*"/>
            <div style="text-align: left">
              <img v-if="editdata.headimg_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+editdata.headimg_url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-tag
            :key="index"
            v-for="(tag,index) in tags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitedit('editdata')">确 定</el-button>
      </div>
    </el-dialog>

    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  export default {
    name: "AudioTheme",
    computed: {
      userdata() {
        return this.$store.state.login.user
      },

    },
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      // this.getstart()
    },
    data() {
      return {
        deleteMoreOrderdata:[],
        ODcurrentPage:1,
        ODpagesize:10,
        ODdatatotal:0,
        detailsOrderData:[],
        DetailsVisible:false,
        bucket : "txcsapp",
        region: "oss-cn-zhangjiakou",
        addid: 'addupload',
        editid: 'editupload',
        tags: [],
        inputVisible: false,
        inputValue: '',
        dataa: [],
        datatotal: 0,
        pagesize: 10,
        currentPage: 1,
        infoVisible: false,
        addVisible: false,
        editVisible: false,
        infodata: {},
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        activeName: '',
        fullscreenLoading: false,
        //表格
        formLabelWidth: '100px',
        adddata: {
          name: '',
          service_content: '',
          score: '',
          price: '',
          cover_url: '',
          tags: '',
        },
        addrules: {
          name: {required: true, message: '请输入', trigger: 'blur'},
          service_content: {required: true, message: '请输入', trigger: 'blur'},
          score: {required: true, message: '请输入', trigger: 'blur'},
          price: {required: true, message: '请输入', trigger: 'blur'},
          cover_url: {required: true, message: '请上传', trigger: 'blur'},
          tags: {required: true, message: '请添加', trigger: 'blur'},
        },
        editdata: {
          name: '',
          service_content: '',
          score: '',
          price: '',
          cover_url: '',
          tags: '',
        },
        editrules: {
          name: {required: true, message: '请输入', trigger: 'blur'},
          service_content: {required: true, message: '请输入', trigger: 'blur'},
          score: {required: true, message: '请输入', trigger: 'blur'},
          price: {required: true, message: '请输入', trigger: 'blur'},
          cover_url: {required: true, message: '请上传', trigger: 'blur'},
          tags: {required: true, message: '请添加', trigger: 'blur'},
        },
      }
    },
    watch: {},
    methods: {
      //获取记录详情
      getOrderDetails(aid){
        console.log(aid)
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.reservationList, {
          page : thi.ODcurrentPage,
          pageSize : thi.ODpagesize,
          key: thi.PLselectkey,
          master_id : aid,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if(qcode==200){
            thi.detailsOrderData=qdata;
            thi.ODdatatotal=qtotal;
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      adddoUpload (type) {
        const _this = this
        const urls = [];
        _this.$http.post('http://sts.txcsok.com/oss.php').then((result) => {
          const client = new OSS.Wrapper({
            region: _this.region,
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            bucket: _this.bucket
          })
          _this.percentage = 0;
          const files = document.getElementById('addupload'+type)
          if (files.files) {
            const fileLen = document.getElementById('addupload'+type).files
            let resultUpload = ''
            for (let i = 0; i < fileLen.length; i++) {
              const file = fileLen[i]
              console.log(file);
              // 随机命名
              let random_name = 'master/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
              console.log(random_name);
              // 上传
              client.multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage*100)
                }
              }).then((results) => {
                // 上传完成
                const url = results.name;
                if(type==1){
                  _this.adddata.cover_url = url;
                }else {
                  _this.adddata.headimg_url = url;
                }
                console.log(url);
              }).catch((err) => {
                console.log(err)
              })
            }
          }
        })
      },
      editdoUpload (type) {
        const _this = this
        const urls = [];
        _this.$http.post('http://sts.txcsok.com/oss.php').then((result) => {
          const client = new OSS.Wrapper({
            region: _this.region,
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            bucket: _this.bucket
          })
          _this.percentage = 0;
          const files = document.getElementById('editupload'+type)
          if (files.files) {
            const fileLen = document.getElementById('editupload'+type).files
            let resultUpload = ''
            for (let i = 0; i < fileLen.length; i++) {
              const file = fileLen[i]
              console.log(file);
              // 随机命名
              let random_name = 'master/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
              console.log(random_name);
              // 上传
              client.multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage*100)
                }
              }).then((results) => {
                // 上传完成
                const url = results.name;
                if(type==1){
                  _this.editdata.cover_url = url;
                }else {
                  _this.editdata.headimg_url = url;
                }
                console.log(url);
              }).catch((err) => {
                console.log(err)
              })
            }
          }
        })
      },

      // 随机生成文件名
      random_string(len) {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
        var maxPos = chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      },
      Tags(tags){
        return tags.split(",")
      },
      details(row){
        let thi = this
        thi.infodata = JSON.parse(JSON.stringify(row));
        thi.infoVisible = true
      },
      gohref(name){
        this.$router.push({name:name})
      },
      addddd(){
        let thi = this
        thi.adddata ={
          name: '',
          service_content: '',
          score: '',
          price: '',
          cover_url: '',
          tags: '',
        }
        thi.addVisible = true
      },
      //修改
      editvalue(row) {
        this.editdata = JSON.parse(JSON.stringify(row))

        console.log(this.editdata)
        this.tags=[]
        if(this.editdata.tags){
          this.tags=this.editdata.tags.split(",")
        }
        this.editVisible = true
      },
      submitadd(formName) {
        let thi=this
        console.log(thi.tags)
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            if(thi.tags.length==0){
              thi.adddata.tags = ''
            }else {
              var tagss = '';
              thi.tags.forEach(function(avalue,aindex,aarr){
                if(aindex==0){
                  tagss = avalue
                  console.log(avalue)
                }else {
                  tagss = tagss+','+avalue
                }
              });
              thi.adddata.tags = tagss
            }
            console.log( thi.adddata)
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.addMaster,
              thi.adddata
            ).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if (qcode == 200) {
                thi.addVisible = false
                thi.fullscreenLoading = false
                thi.getstart()
              } else {
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
                thi.fullscreenLoading = false
              }
            }).catch(function (error) {
              console.log(error)
            });

          } else {
            return false;
          }
        });
      },
      submitedit(formName) {
        let thi=this
        console.log(thi.tags)
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            if(thi.tags.length==0){
              thi.editdata.tags = ''
            }else {
              var tagss = '';
              thi.tags.forEach(function(avalue,aindex,aarr){
                if(aindex==0){
                  tagss = avalue
                  console.log(avalue)
                }else {
                  tagss = tagss+','+avalue
                }
              });
              thi.editdata.tags = tagss
            }
            thi.fullscreenLoading = true
            console.log(thi.editdata)
            thi.$http.post(global.posturl.host + global.posturl.editMaster,
              thi.editdata
            ).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if (qcode == 200) {
                thi.editVisible = false
                thi.fullscreenLoading = false
                thi.getstart()
              } else {
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
                thi.fullscreenLoading = false
              }
            }).catch(function (error) {
              console.log(error)
            });

          } else {
            return false;
          }
        });
      },
      //显示订单详情
      showOrderDetails(data){
        this.DetailsVisible=true
        this.getOrderDetails(data.master_id)
      },
      //记录详情选择展示数量
      ODhandleSizeChange(val) {
        this.ODpagesize=val
        this.getstart()
      },
      //记录详情分页跳转页面
      ODhandleCurrentChange(val) {
        this.ODcurrentPage=val
        this.getstart()
      },
      handleClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.tags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      panduanleixing2(type) {
        switch (type) {
          case '1':
            return "";
            break;
          case '2':
            return "success";
            break;
          case '3':
            return "success";
            break;
          case '4':
            return "info";
            break;
          default:
            return null;
        }
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.masterList, {
          page: thi.currentPage,
          pageSize: thi.pagesize
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.dataa = qdata
            thi.datatotal = qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },

      handleNodeClick(data) {
        console.log(data);
      },

      //删除提示
      changevaluestate(theme_id, state) {
        var heeh = '该'
        var caozuo = '禁用'
        if (theme_id.length > 1) {
          heeh = '这些'
        }
        if (state == 0) {
          caozuo = '删除'
        }
        let thi = this
        thi.$confirm('此操作将' + caozuo + heeh + '账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.submitchangestate(theme_id, state)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消' + caozuo
          });
        });
      },
      //状态改变(删除)
      submitchangestate(theme_id, state) {
        console.log(theme_id)
        console.log(state)
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.masterStateChange, {
          master_id: theme_id,
          state: state,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //状态改变(接单状态)
      changeStateJd(theme_id, state) {
        console.log(theme_id,state)
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.masterjdStateChange, {
          master_id: theme_id,
          jdstate	: state,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //格式化时间
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/page/master/Master.vue